import { fallbackLocale, rightToLeftLocales } from 'constants/localization';

export const textDirection = (language = fallbackLocale) => {
  const { normalizedCode } = language;
  return rightToLeftLocales.includes(normalizedCode) ? 'rtl' : 'initial';
};
